import {
  flow,
  formatDate,
  UNSTABLE_utcOffset as utcOffset,
} from '@yandex-delivery/utils'
import {
  getLocalStorageTimeZone,
  getTimeZoneUtcOffset,
} from '@yandex-delivery/utils/timezone'
import {i18n} from 'src/shared/config'

/**
 * Смещение UTC от выбранной временной зоны пользователя
 */
const __timeZoneUtcOffset = getTimeZoneUtcOffset(getLocalStorageTimeZone())

/**
 * Преобразование даты в локальную дату
 */
const toDate = (dateLike: Date | string) => new Date(dateLike)

/**
 * Преобразование даты в локальную дату
 */
const toLocalDate = __timeZoneUtcOffset
  ? utcOffset(__timeZoneUtcOffset)
  : toDate

/**
 * Преобразование даты в формат HH:MM
 */
const convertMinutesToStandardTime = (
  minutes: number,
): `${string}:${string}` => {
  const hh = `${Math.floor((minutes / 60) % 60)}`.padStart(2, '0')
  const mm = `${Math.floor(minutes % 60)}`.padStart(2, '0')

  return `${hh}:${mm}`
}

const roundToClosestTime = (date: Date): number => {
  const MINUTES_STEP = 15
  const MILLISECONDS_STEP = 1000 * 60 * MINUTES_STEP

  const roundDate = new Date(
    Math.ceil(date.getTime() / MILLISECONDS_STEP) * MILLISECONDS_STEP,
  )

  return roundDate.getHours() * 60 + roundDate.getMinutes()
}

/**
 * Преобразование даты в формат HH:MM
 */
export const toHoursAndMinutes: (date: string) => string = flow(
  toLocalDate,
  roundToClosestTime,
  convertMinutesToStandardTime,
)

const formatToCalendarDate = formatDate({
  sameDay: i18n('cargo.create.delivery-interval.today', '[Сегодня,] D MMMM'),
  nextDay: i18n('cargo.create.delivery-interval.tomorrow', '[Завтра,] D MMMM'),
  nextWeek: 'D MMMM',
  sameElse: 'D MMMM',
})

export const toLabel: (date: string) => string = flow(
  toDate,
  formatToCalendarDate,
)
